import React, { FunctionComponent, useEffect, useState } from 'react';
import classNames from 'classnames';
import { makeImageUrl } from 'lib/urls';
import flexStyles from 'styles/flex.module.scss';
import styles from 'components/Loading.module.scss';

export interface LoadingProps {
    center?: boolean
}

const MinimumDelayMS = 0;

export const Loading: FunctionComponent<LoadingProps> = ({ center }) => {
    const [delayFinished, setDelayFinished] = useState(false);
    useEffect(() => {
        if (delayFinished) {
            return;
        }
        const timeout = setTimeout(() => setDelayFinished(true), MinimumDelayMS);
        return () => {
            clearTimeout(timeout);
        }
    }, [delayFinished]);
    if (!delayFinished) {
        return null;
    }
    return (
        <div className={classNames(
            flexStyles.flexContainer,
            flexStyles.flexColumn,
            flexStyles.fill,
            center ? flexStyles.center : flexStyles.alignCenter,
        )}>
            <img
                className={styles.loadingImage}
                src={makeImageUrl('surefire-loading-white.gif')}
                alt="Loading"
            />
        </div>
    );
};
Loading.defaultProps = {
    center: true,
};
